import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../shared-styles/flex';
import VerticalCenter from '../../../../shared-styles/vertical-center';
import { BADGE_TYPES } from '../../../../constants';

/**
   * Get the background color of this badge
   * based on it's type
   * @param {object} theme - Theme
   * @param {type} type - Badge Type
   * @return {string} - Background color
   */
const getBackgroundColor = (theme, type) => {
  switch (type) {
    case BADGE_TYPES.late:
      return theme.palette.custom.lateBadge;
    default:
      return theme.palette.custom.lateBadge;
  }
};

export const BadgeContainer = styled.div`
  ${FlexNoAlign}
  border-radius: 8px;
  background-color: ${(props) => getBackgroundColor(props.theme, props.type)};
  width: 70px;
  padding: ${(props) => props.theme.spacing(5)};
  height: 100%;
  display: flex;
  align-items: center;
`;

export const BadgeText = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  color: ${(props) => props.theme.palette.white};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
`;

export const IndicatorContainer = styled.div`
  ${VerticalCenter};
  margin-right: ${(props) => props.theme.spacing(5)};
  margin-left: ${(props) => props.theme.spacing(5)};

`;
